import store from '../store'
import Vue from 'vue'

const rawHeaderLen = 16
const packetOffset = 0
const headerOffset = 4
const verOffset = 6
const opOffset = 8
const seqOffset = 12

let ws = ''

const Client = function (options) {
  const MAX_CONNECT_TIMES = 10
  const DELAY = 2000
  this.options = options || {}
  this.createConnect(MAX_CONNECT_TIMES, DELAY)
}

Client.prototype.createConnect = function (max, delay) {
  const that = this
  if (max === 0) {
    store.dispatch('updateWsLoading', false)
    return
  }
  connect()
  const textDecoder = new TextDecoder()
  function connect () {
    ws = new WebSocket(that.options.wsUrl)
    ws.binaryType = 'arraybuffer'
    ws.onopen = function () {
      console.log('ws open')
      heartCheck.start()

      store.dispatch('updateWsConnectStatus', 'open')
      store.dispatch('updateWsStatus', true)
    }
    ws.onmessage = function (evt) {
      const data = evt.data
      const dataView = new DataView(data, 0)
      const packetLen = dataView.getInt32(packetOffset)
      const op = dataView.getInt32(opOffset)
      // const headerLen = dataView.getInt16(headerOffset)
      // const ver = dataView.getInt16(verOffset)
      // const seq = dataView.getInt32(seqOffset)
      // console.log('receiveHeader: packetLen=' + packetLen, 'headerLen=' + headerLen, 'ver=' + ver, 'op=' + op, 'seq=' + seq)
      switch (op) {
        case 8:
          // auth reply ok 验证回复
          // send a heartbeat to server
          break
        case 3:
          heartCheck.reset()
          // receive a heartbeat from server
          break
        case 20:
          // 客户端下线通知
          // ws.close(1000);
          if (!store.getters.hasTips) {
            window.location.href = '/'
            store.dispatch('updateHasTips', true)
            Vue.prototype.$msgDialog('您的账号已在其他设备或浏览器进入直播间，已退出！', () => {
              store.dispatch('updateHasTips', false)
            })
          }
          break
        case 9:
          // batch message
          for (let offset = rawHeaderLen; offset < data.byteLength; offset += packetLen) {
            // parse
            const packetLen = dataView.getInt32(offset)
            const headerLen = dataView.getInt16(offset + headerOffset)
            const ver = dataView.getInt16(offset + verOffset)
            const msgBody = textDecoder.decode(data.slice(offset + headerLen, offset + packetLen))
            // callback
            messageReceived(ver, msgBody)
          }
          break
        default:
          // var msgBody = textDecoder.decode(data.slice(headerLen, packetLen))
          // console.log("receive: ver=" + ver + " op=" + op + " seq=" + seq + " message=" + msgBody);
          break
      }
    }
    ws.onclose = function (e) {
      console.log(e)
      if (e.code === 1006) {
        if (max > 0) {
          store.dispatch('updateWsLoading', true)
        }
        clearTimeout(heartCheck.timeoutObj)
        clearTimeout(heartCheck.serverTimeoutObj)
        clearTimeout(ws.reConnectTimer)
        ws.reConnectTimer = setTimeout(reConnect, delay)
      }
      store.dispatch('updateWsConnectStatus', 'close')
      store.dispatch('updateWsStatus', false)
    }
    ws.onerror = function () {
      store.dispatch('updateWsConnectStatus', 'error')
      console.log('connect error')
    }
    const heartCheck = {
      timeoutObj: null,
      serverTimeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj)
        clearTimeout(this.serverTimeoutObj)
        this.start()
      },
      start: function () {
        this.timeoutObj = setTimeout(() => {
          heartbeat()
          this.serverTimeoutObj = setTimeout(() => {
            // 如果onclose会执行reconnect，这里直接ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
            ws.close()
          }, that.options.heartbeat * 1000) // 心跳间隔
        }, that.options.heartbeat * 1000)
      }
    }
    function heartbeat () {
      const headerBuf = new ArrayBuffer(rawHeaderLen)
      const headerView = new DataView(headerBuf, 0)
      headerView.setInt32(packetOffset, rawHeaderLen)
      headerView.setInt16(headerOffset, rawHeaderLen)
      headerView.setInt16(verOffset, 1)
      headerView.setInt32(opOffset, 2)
      headerView.setInt32(seqOffset, 1)
      ws.send(headerBuf)
    }
    function messageReceived (ver, body) {
      store.dispatch('handleSocketChat', body)
      // console.log("messageReceived:", "ver=" + ver, "body=" + body);
    }
    function reConnect () {
      if (that.options && !that.options.stop_reconnect) {
        that.createConnect(--max, delay)
      }
    }
  }
}

Client.prototype.sendMsg = function (msgObj, type) {
  var textEncoder = new TextEncoder()
  send(msgObj, type)
  function mergeArrayBuffer (ab1, ab2) {
    const u81 = new Uint8Array(ab1)
    const u82 = new Uint8Array(ab2)
    const res = new Uint8Array(ab1.byteLength + ab2.byteLength)
    res.set(u81, 0)
    res.set(u82, ab1.byteLength)
    return res.buffer
  }
  function send (msg, type) {
    var headerBuf = new ArrayBuffer(rawHeaderLen)
    var headerView = new DataView(headerBuf, 0)
    var bodyBuf = textEncoder.encode(msg)
    headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength)
    headerView.setInt16(headerOffset, rawHeaderLen)
    headerView.setInt16(verOffset, 1)
    headerView.setInt32(opOffset, type)
    headerView.setInt32(seqOffset, 1)
    ws.send(mergeArrayBuffer(headerBuf, bodyBuf))
  }
}

window.MyClient = Client
export default Client
